import { render, staticRenderFns } from "./FooterBanner.vue?vue&type=template&id=1ecf60c0&scoped=true&"
import script from "./FooterBanner.vue?vue&type=script&lang=js&"
export * from "./FooterBanner.vue?vue&type=script&lang=js&"
import style0 from "./FooterBanner.vue?vue&type=style&index=0&id=1ecf60c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecf60c0",
  null
  
)

export default component.exports